import { render } from "./LinkProfile.vue?vue&type=template&id=6b21728e"
import script from "./LinkProfile.vue?vue&type=script&lang=js"
export * from "./LinkProfile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__